var map = {
	"./Bekanntmachung.png": 19236,
	"./Bekanntmachung_fr.png": 51483,
	"./Bekanntmachung_it.png": 89214,
	"./Kindeswohl_Wimmelbild.png": 19627,
	"./Kindeswohl_Wimmelbild_fr.png": 85147,
	"./Kindeswohl_Wimmelbild_it.png": 79488,
	"./Lebensstandard.png": 341,
	"./SexuelleSelbstbestimmung.png": 77845,
	"./SexuelleSelbstbestimmung_fr.png": 26609,
	"./SexuelleSelbstbestimmung_it.png": 38984,
	"./beteiligung_familie.png": 7175,
	"./beteiligung_familie_fr.png": 40642,
	"./beteiligung_familie_it.png": 43514,
	"./gesundheit_psychisch.png": 71098,
	"./gesundheit_psychisch_fr.png": 39800,
	"./gesundheit_psychisch_it.png": 55459,
	"./wimmelbild.jpg": 21874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85702;